import auth from './auth';
import membership from './membership';
import member from './member';
import introductions from './introductions';
import doctors from './doctors';
import motheringClasses from './motheringClasses';
import schedulePictures from './schedulePictures';
import appointment from './appointment';
import feedback from './feedback';
import hibaby from './hibaby';
import satisfactionSurveys from './satisfactionSurveys';
import inboxes from './inboxes';
import progress from './progress';
import progressReminders from './progressReminders';

export default {
  auth,
  membership,
  member,
  introductions,
  doctors,
  motheringClasses,
  schedulePictures,
  appointment,
  feedback,
  hibaby,
  satisfactionSurveys,
  inboxes,
  progress,
  progressReminders,
};
